import * as React from 'react'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined'
import ViewModuleIcon from '@mui/icons-material/ViewModule'

export const IconRoute = (item) => {
  switch (item) {
    case 'subscriber':
      return <PeopleOutlineOutlinedIcon style={{ marginRight: 4 }} />
    case 'organizations':
      return <BusinessOutlinedIcon style={{ marginRight: 4 }} />
    case 'users':
      return <PersonOutlineIcon style={{ marginRight: 4 }} />
    case 'suborganizations':
      return <GroupsOutlinedIcon style={{ marginRight: 4 }} />
    case 'storage':
      return <DnsOutlinedIcon style={{ marginRight: 4 }} />
    case 'security':
      return <SecurityOutlinedIcon style={{ marginRight: 4 }} />
    case 'appearance':
      return <AppsOutlinedIcon style={{ marginRight: 4 }} />
    case 'adminModules':
      return <ViewModuleIcon style={{ marginRight: 4 }} />
    default:
      return null
  }
}
